import type { StorageAdapter } from "../auth/storage";

let _storageAdapter: StorageAdapter | null = null;
const STORAGE_KEY = "hops-panel-server-url";

/** Call this before using server URL persistence. */
export function initServerUrlStorage(adapter: StorageAdapter) {
  _storageAdapter = adapter;
}

/** Read persisted server URL from storage. Returns null if none saved. */
export async function getPersistedServerUrl(): Promise<string | null> {
  if (!_storageAdapter) return null;
  return _storageAdapter.getItem(STORAGE_KEY);
}

/** Persist the server URL to storage. */
export async function persistServerUrl(url: string): Promise<void> {
  await _storageAdapter?.setItem(STORAGE_KEY, url);
}
